<template>
    <main>
        <section>
            <div class="content-960">
                <div class="row">
                    <section class="col-sm-6">
                        <ul class="breadcrumb">
                            <li><a href="#" title="Home">CNA BOX</a></li>
                            <li>Alíquota Simples Nacional</li>
                        </ul>
                    </section>
                    <section class="col-sm-6">
                        <button class="btn-large-40 btn-success uppercase pull-right btn-header" @click="openCreate()">
                            Criar
                        </button>
                    </section>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <b-alert show variant="primary" class="text-justify">
                            De acordo com a <a href="http://www.planalto.gov.br/ccivil_03/leis/lcp/lcp123.htm" target="blank" class="alert-link">Lei Complementar 123</a>, os estabelecimentos de ensino de língua estrangeira devem ser tributados conforme o disposto no Anexo III da própria lei.<br />
                            É necessário que acompanhemos a vigência e atualizações deste anexo para cadastrar as novas regras (quando houver) para que o Demonstrativo Financeiro do CNA Box faça o cálculo do imposto a se pagar adequadamente.<br />
                            Quando houver atualização, <b>os registros já existentes devem ser mantidos inalterados para que o CNA Box não perca as referências para os relatórios já gerados</b>. As novas faixas e regras devem ser cadastradas como novos registros.
                        </b-alert>
                    </div>
                </div>
            </div>

            <div class="content-960 mobile-row">
                <div class="wrapper-960 clearfix">
                    <div class="titles icons icon-news-middle">
                        <h2 class="uppercase"><b>Alíquota Simples Nacional</b></h2>
                    </div>

                    <div class="mold-txt-center">
                        <form v-on:submit.prevent="executeFilter(filter)">
                            <div class="row">
                                <div class="form-group col-md-4">
                                    <label for="faixa">Faixa</label>
                                    <input type="text" class="form-control" name="faixa" placeholder="Nome da Faixa" v-model="filter.faixa" />
                                </div>
                                <div class="form-group col-md-2">
                                    <label for="inicioVigencia">Início Vigência</label>
                                    <input type="text" v-mask="'##/##/####'" maxlength="10" v-datepicker class="form-control" name="inicioVigencia" placeholder="__/__/____" v-model="filter.inicioVigencia" />
                                </div>
                                <div class="form-group col-md-2">
                                    <label for="terminoVigencia">Término Vigência</label>
                                    <input type="text" v-mask="'##/##/####'" maxlength="10" v-datepicker class="form-control" name="terminoVigencia" placeholder="__/__/____" v-model="filter.terminoVigencia" />
                                </div>

                                <div class="form-group col-md-4">
                                    <label>Vigência</label>
                                    <div class="form-group">
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="vigente" v-model="filter.vigente" value="undefined" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Todos</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="vigente" v-model="filter.vigente" value="true" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Vigênte</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="vigente" v-model="filter.vigente" value="false" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Não Vigênte</span>
                                        </label>
                                    </div>
                                </div>

                            </div>
                            <button type="button" class="btn-large-40 btn-red uppercase" @click="executeFilter(filter)">Buscar</button>
                        </form>
                    </div>

                    <div class="table-responsive standard-table header-cinza">
                        <table>
                            <thead>
                                <tr>
                                    <th>Id<i @click="executeOrderBy('AliquotaSimplesNacionalId')" class="fa fa-sort"></i></th>
                                    <th>Faixa<i @click="executeOrderBy('Faixa')" class="fa fa-sort"></i></th>
                                    <th>Início Vigência<i @click="executeOrderBy('InicioVigencia')" class="fa fa-sort"></i></th>
                                    <th>Término Vigência<i @click="executeOrderBy('TerminoVigencia')" class="fa fa-sort"></i></th>
                                    <th>Receita Bruta Anual (De)<i @click="executeOrderBy('ReceitaBrutaAnualDe')" class="fa fa-sort"></i></th>
                                    <th>Receita Bruta Anual(Ate)<i @click="executeOrderBy('ReceitaBrutaAnualAte')" class="fa fa-sort"></i></th>
                                    <th>Alíquota<i @click="executeOrderBy('Aliquota')" class="fa fa-sort"></i></th>
                                    <th>Valor A Deduzir<i @click="executeOrderBy('ValorDeduzir')" class="fa fa-sort"></i></th>
                                    <th>Situação<i @click="executeOrderBy('Vigente')" class="fa fa-sort"></i></th>
                                    <th class="text-center" width="150"><i class="fa fa-cog"></i></th>
                                </tr>
                            </thead>
                            <tbody>

                                <tr v-for="item in result.items" v-bind:key="item.tagJobsId" class="animated fadeIn">
                                    <td>{{ item.aliquotaSimplesNacionalId }}</td>
                                    <td>{{ item.faixa }}</td>
                                    <td>{{ item.inicioVigencia }}</td>
                                    <td>{{ item.terminoVigencia }}</td>
                                    <td>{{ formatPrice(item.receitaBrutaAnualDe) }}</td>
                                    <td>{{ formatPrice(item.receitaBrutaAnualAte) }}</td>
                                    <td>{{ item.aliquota + '%' }}</td>
                                    <td>{{ formatPrice(item.valorDeduzir) }}</td>
                                    <td><span class="badge badge-pill" v-bind:class="{ 'badge-success': item.vigente, 'badge-danger': !item.vigente }">{{item.vigente ? 'Vigente' : 'Não Vigente'}}</span></td>

                                    <td class="text-center">
                                        <button type="button" class="btn btn-sm btn-primary" @click="openEdit({ aliquotaSimplesNacionalId: item.aliquotaSimplesNacionalId })">
                                            <i class="fa fa-pencil"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="card-block no-padding">
                        <pagination :total="result.total" :page-size="filter.pageSize" :callback="executePageChanged"></pagination>
                    </div>

                </div>
            </div>
        </section>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" size="lg" centered v-model="dialogCreate" :hide-footer="true" title="Criar">
            <form-create v-if="dialogCreate" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" size="lg" centered v-model="dialogEdit" :hide-footer="true" title="Editar">
            <div class="row">
                <div class="col-sm-12">
                    <b-alert show variant="danger" class="text-justify">
                        <b>IMPORTANTE!</b> Ao editar os valores cadastrados, tenha em mente que os demonstrativos financeiros gerados antes da edição levaram em consideração os valores antigos. Leve em consideração a necessidade de atualizá-los.
                    </b-alert>
                </div>
            </div>
            <form-edit v-if="dialogEdit" :id="aliquotaSimplesNacionalId" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogRemove" title="Confirmação">
            <p>Tem certeza que deseja remover este item?</p>
            <div slot="modal-footer">
                <button class="btn btn-sm btn-danger" @click="executeRemove()">
                    Remover
                </button>
            </div>
        </b-modal>

    </main>

</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    import formCreate from './form-create'
    import formEdit from './form-edit'

    export default {
        name: 'aliquotasimplesnacional',
        mixins: [base],
        components: { formCreate, formEdit },
        data() {
            return {

                resources: {
                    filter: 'aliquotasimplesnacional',
                    remove: 'aliquotasimplesnacional'
                },

                dialogRemove: false,
                dialogCreate: false,
                dialogEdit: false,

                model: {},
                filter: {
                    pageSize: 50,
                    pageIndex: 1,
                    isPagination: true,
                },

                result: {
                    total: 0,
                    items: []
                }
            }
        },
        methods: {
            openEdit: function (model) {
                this.aliquotaSimplesNacionalId = model.aliquotaSimplesNacionalId;
                this.dialogEdit = true;
            },
            openCreate: function () {
                this.dialogCreate = true;
            },
            onSaved: function () {
                this.hideAll();
                this.executeLoad();
            },
            hideAll: function () {
                this.dialogCreate = false;
                this.dialogEdit = false;
                this.dialogRemove = false;
            },

            openRemove: function (model) {
                this.dialogRemove = true;
                this.model = model;
            },
            executeRemove: function (model) {
                if (model) this.model = model;
                new Api(this.resources.remove).delete(this.model).then(() => {
                    this.defaultSuccessResult("Item removido com sucesso");
                    this.hideAll();
                    this.executeLoad();
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            executeFilter: function (filter) {
                if (filter) this.filter = filter;
                this.executeLoad();
            },
            executePageChanged: function (index) {
                this.filter = this.defaultPageChanged(this.filter, index);
                this.executeLoad();
            },
            executeOrderBy: function (field) {
                this.filter = this.defaultOrderBy(this.filter, field);
                this.executeLoad();
            },
            executeLoad: function () {
                let dataInicio = document.getElementsByName('inicioVigencia')[0].value;
                let dataTermino = document.getElementsByName('terminoVigencia')[0].value;
                if (this.validaDatasFilter(dataInicio,dataTermino) == true) {
                    this.defaultErrorResult('Data de término de vigência não pode ser inferior a data de início de vigência, favor verificar!');
                    return;
                }

                this.showLoading();
                new Api('aliquotasimplesnacional/getaliquotasimplesnacional').get(this.filter).then(data => {
                    if (data.summary) this.result.total = data.summary.total;
                    this.result.items = data.dataList;
                    this.hideLoading();
                }, (err) => {
                    this.failLoading();
                    if (err && err.data && err.data.errors) {
                        this.$eventHub.$emit('show-notification', {
                            type: 'error',
                            title: 'Atenção',
                            text: err.data.errors[0]
                        })
                    }
                });
            },

            validaDatasFilter: function (dataInicio,dataTermino) {
                let arrDataIni = dataInicio.split('/');
                let arrDataTer = dataTermino.split('/');
                let stringDataIniFormatada = arrDataIni[1] + '-' + arrDataIni[0] + '-' + arrDataIni[2];
                let stringDataTerFormatada = arrDataTer[1] + '-' + arrDataTer[0] + '-' + arrDataTer[2];
                let newDateIni = new Date(stringDataIniFormatada);
                let newDateTer = new Date(stringDataTerFormatada);

                if (newDateTer < newDateIni)
                return true
                
                return false;
            }

        },

        mounted() {
            this.executeFilter();
        }

    };
</script>